import React from 'react';

import { Paper, Typography, WarningIcon, makeStyles } from '@gogame/components';

const useStyles = makeStyles(() => ({
  root: {
    position: 'fixed',
    top: 0,
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2px 6px',
    borderRadius: '0px 0px 4px 4px',
    zIndex: 2,
  },
  label: {
    padding: '0 4px',
  },
}));

const UnAppliedChanges = () => {
  const classes = useStyles();
  return (
    <Paper elevation={8} className={classes.root}>
      <WarningIcon sx={{ fontSize: 14 }} color={'warning'} />
      <Typography className={classes.label} variant={'caption'}>
        Unapplied changes
      </Typography>
    </Paper>
  );
};

export default UnAppliedChanges;
